
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const app = namespace("app");

@Component({})
export default class AmountDiffTips extends Vue {
  @app.State btnLoading;

  amountDiffTipsShow = false;
  open() {
    this.amountDiffTipsShow = true;
  }
  handleSkipPrompt() {
    this.$emit("confirm");
  }
  close() {
    this.amountDiffTipsShow = false;
  }
}
